import React from 'react';
import CheckIcon from '@atlaskit/icon/glyph/check';
import { Inline, Text, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { Status } from '@atlassian/jira-project-create-importer-common';

const SUCCESS_ICON_COLOR = token('color.icon.success', colors.G500);

type Props = {
	status: Status;
	description: string;
};

const getIcon = (status: Status) =>
	status === Status.SUCCESS ? (
		// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
		<CheckIcon
			label=""
			primaryColor={SUCCESS_ICON_COLOR}
			size="small"
			testId="project-create-importer-upload-flow.ui.import-in-progress-screen.import-step-progress.check-icon"
		/>
	) : (
		<Spinner
			size="small"
			testId="project-create-importer-upload-flow.ui.import-in-progress-screen.import-step-progress.spinner"
		/>
	);

export const ImportStepProgress = ({ status, description }: Props) => (
	<Inline
		testId="project-create-importer-upload-flow.ui.import-in-progress-screen.import-step-progress.wrapper"
		alignBlock="center"
		xcss={stepWrapper}
		space="space.200"
	>
		{getIcon(status)}
		<Text as="span">{description}</Text>
	</Inline>
);

const stepWrapper = xcss({
	minHeight: token('space.300', '24px'),
});
